<template>
  <v-container class="home">
    <v-row class="my-2">
      <v-col>
        <v-sheet outlined style="text-align: center" class="crane-border-orange">
          <v-row>
            <v-col><h2 class="mt-5">Hours</h2></v-col>
          </v-row>
          <v-row class="ma-3">
            <v-col style="width: 100%; overflow: auto;">
            <iframe
              src="https://calendar.google.com/calendar/embed?src=c_625ccii0dq83im5558ptntmb3s%40group.calendar.google.com&ctz=America%2FNew_York"
              style="border: 0"
              width="800"
              height="400"
              frameborder="0"
              scrolling="no"
              class="mx-auto"
            ></iframe>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data: () => ({
    lectures: [
      {
        date: "Jan 20",
        topic: "1. Intro. to CS167 and OS",
        reading: "Sections 1.1 and 1.2",
        downloads: "blobfish.jpg",
      },
    ],
  }),
};
</script>
<style scoped>

@import '../styles/crane.css';

.profile {
  width: 250px;
  margin: auto;
}

.profile img {
  width: 200px;
  height: 200px;
  object-fit: cover;
}

</style>